import { fromJS } from "immutable";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import DroppableAreas from "../../containers/Frame/DroppableAreas";
import { getFrameSvgId } from "../../helpers/frameHelper";

const SVG = styled.svg`
    overflow: visible;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
`;

function ReturnSVG(props) {
    return (
        <div id={props.id}>
            <SVG width={props.width} height={props.height}>
                <path d={props.d} fill={props.fill} stroke={props.stroke} />
            </SVG>
        </div>
    );
}

function FramesComponent(props) {
    const frameContainerRef = useRef(null);
    const canAllowClick = useRef(false);

    const {
        id, grouped, groupId, frameItem, zoomFactor, propertyWindow, socket,
        transformStatus, isSlidePreview, idPrefix, slidesPanelZoomFactor
    } = props;

    const _zoomFactor = isSlidePreview ? slidesPanelZoomFactor : zoomFactor;

    const isFrameVisible = true;

    function renderDroppables() {
        const frameClipDetails = frameItem.get("clipDetails");

        let frameDetails = [];
        frameClipDetails.entrySeq().forEach(([key, item], ind) => {
            console.log(ind)
            frameDetails.push(
                <DroppableAreas
                    key={key}
                    Id={id}
                    clip_id={key}
                    groupId={groupId}
                    selectedItem={id}
                    isGrouped={grouped}
                    droppableItemData={fromJS(item)}
                    frameItemData={fromJS(frameItem)}
                    socket={socket}
                    totalLength={frameClipDetails.size}
                    currIndex={ind}
                    isPlay={props.isPlay}
                    isPlayAll={props.isPlayAll}
                    onLoadData = {(imageId) => onLoadData(imageId)}
                    isFrameVisible={isFrameVisible}
                    isSlidePreview={isSlidePreview}
                    idPrefix={idPrefix}
                />
            );
        });

        return frameDetails;
    }

    const onLoadData = (imageId) => {
        try {
            // if ((props.isFullScreen === true)) {
                window.totalArr = window.totalArr.filter(e => e !== imageId);
                console.log(window.totalArr, "window.totalArr", imageId)
                // if (window.totalArr.length === 0) {
                //     props.startPlay("workspace")
                // }
            // }
        } catch (error) {
            console.log(error)
        }
    }
    function frameContainerStyles() {
        const defaultWidth = frameItem.get("defaultWidth");
        const defaultHeight = frameItem.get("defaultHeight");
        const frameWidth = frameItem.get("width") * _zoomFactor;
        const frameHeight = frameItem.get("height") * _zoomFactor;

        return {
            width: `${defaultWidth}px`,
            height: `${defaultHeight}px`,
            transform: `scaleX(${frameWidth / defaultWidth}) scaleY(${frameHeight / defaultHeight
                })`,
            transformOrigin: "0 0",
        };
    }

    function renderSVGs() {
        return frameItem.get("d").map((item, key) => {
            return (
                <ReturnSVG
                    key={key}
                    id={getFrameSvgId(id, key, idPrefix)} // for color pallete
                    d={item.get("path")}
                    fill={item.get("fill")}
                    stroke={item.get("stroke")}
                    width={item.get("width")}
                    height={item.get("height")}
                />
            );
        });
    }

    return (
        <div
            className={`inner-frame ${id + 1}`}
            style={frameContainerStyles()}
            ref={frameContainerRef}
        >
            {renderSVGs()}
            {renderDroppables()}
        </div>
    );
}

export default FramesComponent;


// WEBPACK FOOTER //
// ./src/components/Frame/FramesComponent.js